import React, { useContext, useEffect, useState } from "react";
import classNames from "lib/classNames";
import SetupStep from "./SetupStep";
import { LIST_SHOP_CAMPAIGNS } from "Queries";
import UserContext from "context/UserContext";
import ShopContext from "context/ShopContext";
import { useQuery } from "@apollo/react-hooks";
import useReactRouter from "use-react-router";
import { API_GATEWAY_NEW, APP_DEV, SHOPIFY_API_KEY } from "aws-exports";
import EmbeddedContext from "context/EmbeddedContext";
import { Redirect } from "@shopify/app-bridge/actions";
import Axios from "axios";
import { Loading, Toast, Modal } from "@shopify/app-bridge-react";
import ContentLoader from "react-content-loader";
import { getScriptStatus } from "./cart/Utils";

const SetupGuide = () => {
  const { history, location } = useReactRouter();
  const shopContext = useContext(ShopContext);
  const [showInstallationModel, setShowInstallationModel] = useState(false);
  const {
    AppLocalStorage,
    setup: { cartActive, cartLoading },
  } = shopContext;
  const user = useContext(UserContext);
  let { data } = useQuery(LIST_SHOP_CAMPAIGNS, {
    variables: {
      userId: user.attributes.sub,
    },
    fetchPolicy: "network-only",
  });
  const { AppBridgeRedirect } = useContext(EmbeddedContext);

  const [collapsed, setCollapsed] = useState(true);

  const [campaignActive, setCampaignActive] = useState(false);
  const [dataLoading, setDataLoading] = useState(true);
  const [designActive, setDesignActive] = useState(false);
  const [completedTasks, setCompletedTasks] = useState(0);

  useEffect(() => {
    const app_first_turn_on = AppLocalStorage.getItem("first_cart_turn_on");
    setDesignActive(app_first_turn_on);
  }, [AppLocalStorage]);

  useEffect(() => {
    if (data) {
      if (data.campaigns?.list?.length) {
        setCampaignActive(
          !!data.campaigns.list.find((campaign) => campaign.active)
        );
      }
      setDataLoading(false);
    }
  }, [data]);

  useEffect(() => {
    if (!dataLoading && !cartLoading) {
      let total = +cartActive + +designActive + +campaignActive;
      setCompletedTasks(total);
      setCollapsed(total === 3);
    }
  }, [cartActive, designActive, campaignActive, cartLoading, dataLoading]);

  return (
    <div className={classNames("col-span-1 lg:col-span-3")}>
      <div className={classNames("flex-1 mb-3")}>
        <b className={classNames("text-gray-600 text-lg")}>
          Welcome To Monster Cart Upsells 🥰
        </b>
        <p
          className={classNames("text-gray-600 font-normal text-md mt-1 mb-4")}
        >
          Here are a few steps to get started. Reach out to the team if you need
          help.
        </p>
      </div>
      <div className={classNames("bg-white relative rounded shadow")}>
        <div className={classNames("py-6 px-8")}>
          <div className={classNames("flex items-center justify-between")}>
            {dataLoading || cartLoading ? (
              <ContentLoader
                className={classNames("mb-3 rounded h-4")}
                viewBox="0 0 400 12"
                style={{ width: 100 }}
              >
                <rect x="0" y="0" width="400" height="12" />
              </ContentLoader>
            ) : (
              <>
                <h3 className={classNames("font-bold mb-3 text-gray-600")}>
                  Setup Guide
                </h3>
                <div
                  className={classNames("mb-3 cursor-pointer")}
                  style={{
                    transform: collapsed ? "rotate(180deg)" : "rotate(0deg)",
                    transition: "transform 0.4s ease",
                  }}
                  onClick={() => {
                    setCollapsed(!collapsed);
                  }}
                >
                  <svg
                    className={classNames("w-4 h-3")}
                    viewBox="0 0 14 8"
                    fill="none"
                  >
                    <path
                      d="M1 1L7 7L13 1"
                      stroke="#718096"
                      strokeWidth="3"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              </>
            )}
          </div>
          <div
            className={classNames(
              "flex items-center flex-wrap space-y-3 sm:space-y-0"
            )}
          >
            {dataLoading || cartLoading ? (
              <>
                <ContentLoader
                  viewBox="0 0 400 12"
                  className={classNames("flex-1 w-1/5 h-4 mr-3 rounded")}
                >
                  <rect x="0" y="0" width="400" height="12" />
                </ContentLoader>
                <ContentLoader
                  viewBox="0 0 400 12"
                  className={classNames("w-3/4 h-4 rounded-lg")}
                >
                  <rect x="0" y="0" width="400" height="12" />
                </ContentLoader>
              </>
            ) : (
              <>
                <p className={classNames("flex-1 text-gray-600 text-sm")}>
                  {completedTasks} of 3 tasks completed
                </p>
                <div
                  className={classNames(
                    "flex w-3/4 h-3 rounded-md relative overflow-hidden mix-blend-darken bg-white"
                  )}
                  style={{
                    background: "rgba(93, 120, 240, 0.2)",
                  }}
                >
                  <div
                    className={classNames(
                      "block transition-width absolute inset-0 duration-500 ease-out z-10"
                    )}
                    style={{
                      background: completedTasks < 3 ? "#5D78F0" : "#48bb78",
                      width: `${(completedTasks * 100) / 3}%`,
                    }}
                  ></div>
                </div>
              </>
            )}
          </div>
        </div>
        {/* <div className={classNames("w-full h-px bg-gray-400")}></div> */}
        <div
          className={classNames("relative overflow-hidden")}
          style={{
            maxHeight: collapsed ? "0px" : "450px",
            transition: "max-height 0.4s ease",
          }}
        >
          <div
            className={classNames(
              "border-gray-400 border-solid border-t pt-0 px-8 pb-6"
            )}
          >
            <SetupStep
              title={`1.  Review Monster Cart Design`}
              description={`The Monster Cart comes with great preset options. However you can customize them further to match your brand`}
              actionText="Open Cart Setup"
              action={() => history.push("/settings" + location.search)}
              done={designActive}
            />
            <SetupStep
              title={`2.  Activate Monster Cart`}
              description={`Activate Monster Cart App embed block in your theme editor. \nFind it in Theme settings > App embeds. Make sure you click save.`}
              required
              actionText="Enable / Disable Cart"
              action={() => {
                setShowInstallationModel(true);
              }}
              done={cartActive}
            />
            <SetupStep
              title={`3.  Activate Upsell Campaigns`}
              description={`Increase your average order value by displaying high converting upsell campaigns in your cart. Be sure to check out our best practise guides or reach out to the team if needed`}
              recommended
              actionText="Add Upsells"
              action={() => history.push("/campaigns/create" + location.search)}
              done={campaignActive}
            />
          </div>
        </div>
      </div>
      <Modal
        size="Large"
        title="Installation"
        open={!!showInstallationModel}
        primaryAction={{
          content: "Open Editor",
          onAction: function () {
            const activateAppId = APP_DEV
              ? "13fae760-4743-463c-aaeb-80cebaccc364"
              : "a1b8e58a-bf1d-4e0f-8768-a387c3f643c0";
            const deepLink = `/themes/current/editor?context=apps&template=product&activateAppId=${activateAppId}/app-embed`;
            AppBridgeRedirect.dispatch(Redirect.Action.ADMIN_PATH, {
              path: deepLink,
              newContext: true,
            });
          },
        }}
        secondaryActions={[
          {
            content: "Watch Tutorial",
            onAction: () => {
              AppBridgeRedirect.dispatch(Redirect.Action.REMOTE, {
                url: "https://monsterapps.crisp.help/en/article/activate-deactivate-monster-cart-19okfn1/",
                newContext: true,
              });
            },
          },
        ]}
        src={`${window.location.origin}/AppThemeExtensionInstallation.html`}
        onClose={() => setShowInstallationModel(false)}
      />
    </div>
  );
};

export default SetupGuide;
